"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AlertComponent.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _alertReducer = require('shared/reducers/alertReducer');

const AlertTypesMap = {
  [_alertReducer.AlertTypes.SUCCESS]: {
    class: 'success',
    icon: 'check_circle',
  },
  [_alertReducer.AlertTypes.INFORMATION]: {
    class: 'information',
    icon: 'priority_high',
  },
  [_alertReducer.AlertTypes.DANGER]: {
    class: 'danger',
    icon: 'warning',
  },
  [_alertReducer.AlertTypes.ERROR]: {
    class: 'error',
    icon: 'error',
  },
}

const ALERT_TIME = 3500








const AlertComponent = ({
  title,
  body,
  type = _alertReducer.AlertTypes.INFORMATION,
  onClose,
}) => {
  const [xpressed, setXpressed] = _react.useState.call(void 0, false)
  const [applyPressure, setApplyPressure] = _react.useState.call(void 0, false)
  const [slideOut, setSlideOut] = _react.useState.call(void 0, false)

  const clearTimeoutRef = _react.useRef(undefined)
  const alertLifeTimerRef = _react.useRef(undefined)
  // The timers fire after later renders; always call the latest onClose,
  // as the class read this.props.onClose at fire time.
  const onCloseRef = _react.useRef.call(void 0, onClose)
  _react.useLayoutEffect.call(void 0, () => {
    onCloseRef.current = onClose
  })

  const scheduleClose = _react.useCallback.call(void 0, (time) => {
    if (clearTimeoutRef.current) {
      window.clearTimeout(clearTimeoutRef.current)
    }
    clearTimeoutRef.current = setTimeout(() => {
      // wait for animation to complete
      onCloseRef.current()
    }, time)
  }, [])

  const restartComponentLifeSpan = _react.useCallback.call(void 0, () => {
    if (alertLifeTimerRef.current) {
      window.clearTimeout(alertLifeTimerRef.current)
    }
    alertLifeTimerRef.current = setTimeout(() => {
      setSlideOut(true)
      scheduleClose(800) // this should match 'top' and 'left' animation durations in _alert.scss
    }, ALERT_TIME)
  }, [scheduleClose])

  _react.useEffect.call(void 0, () => {
    restartComponentLifeSpan()
    return () => {
      window.clearTimeout(clearTimeoutRef.current)
      window.clearTimeout(alertLifeTimerRef.current)
    }
  }, [restartComponentLifeSpan])

  const mouseDown = () => {
    setApplyPressure(true)
  }

  const mouseUp = () => {
    if (applyPressure) {
      // user started click on x icon, but mouse may have drifed off icon, still close box
      setXpressed(true)
      scheduleClose(100) // this should match 'opacity' animation duration in _alert.scss
    }
  }

  const mouseOverComponent = () => {
    // user is probably reading component, don't close it
    if (alertLifeTimerRef.current) {
      window.clearTimeout(alertLifeTimerRef.current)
    }
  }

  const mouseLeaveComponent = () => {
    setApplyPressure(false)
    restartComponentLifeSpan()
  }

  const alertClasses = `blm-alert
      ${xpressed ? ' fade' : ''} 
      ${applyPressure ? ' pressure' : ''}
      ${slideOut ? ' slideout' : ''}`

  const typeMap = AlertTypesMap[type]
  return (
    _react2.default.createElement('div', { className: alertClasses, onMouseLeave: mouseLeaveComponent, onMouseOver: mouseOverComponent, onMouseUp: mouseUp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
      , _react2.default.createElement('i', { className: `material-icons ${typeMap.class}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, typeMap.icon)
      , _react2.default.createElement('div', { className: "blm-alert--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
        , _react2.default.createElement('div', { className: "blm-alert-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}, title)
        , _react2.default.createElement('div', { className: "blm-alert-message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}, body)
      )
      , _react2.default.createElement('i', { className: "material-icons", onMouseDown: mouseDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}, "close")
    )
  )
}

exports. default = AlertComponent
